import automationHeader from '../../components/dashboard/paywall/sales-activated-trial/page/images/automations-header.png';
import automationSection1 from '../../components/dashboard/paywall/sales-activated-trial/page/images/automations-section1.png';
import automationSection2 from '../../components/dashboard/paywall/sales-activated-trial/page/images/automations-section2.png';
import automationSection3 from '../../components/dashboard/paywall/sales-activated-trial/page/images/automations-section3.png';
import type { PageblockData } from '../pageblockTypes';

export const PAGEBLOCK_DATA_AUTOMATIONS: PageblockData = {
  headerData: {
    headerText: 'Build custom Salesforce automations ',
    subHeaderText:
      'Create no-code, native Salesforce automations to streamline your team’s workflows.',
    imgSrc: automationHeader,
    imgAlt: 'Automations header',
    name: 'Automations',
  },
  pageTitle: 'Unlock seamless automation for complex workflows in Salesforce',
  section1: {
    imgSrc: automationSection1,
    imgAlt: 'Automations section img',
    title: 'Record creation & updates',
    content:
      'Automate the creation and updating of Salesforce records to maintain data integrity and optimize workflows across teams.',
  },
  section2: {
    imgSrc: automationSection2,
    imgAlt: 'Automations section 2 img',
    title: 'Process orchestration',
    content:
      'Automate complex, multi-step workflows with conditional logic and tasks assignments to ensure consistent and efficient process execution.',
  },
  section3: {
    imgSrc: automationSection3,
    imgAlt: 'Automations section 3 img',
    title: 'Execute third party integrations',
    content:
      'Automate the creation and updating of Salesforce records to maintain data integrity and optimize workflows across teams.',
  },
};
